import React from "react";
import { connect } from "react-redux";
import {
  Button,
  CssBaseline,
  TextField,
  Paper,
  Typography,
  Container,
  withStyles,
  Box
} from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { Helmet } from "react-helmet";
import { PatientActions } from "../../redux/actions/PatientActions";
import { DynamicFormActions } from "../../redux/actions/DynamicFormAction";
import { history } from "../helpers/History";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Checkbox from "@material-ui/core/Checkbox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(3),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
});

class AssignDocument extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patientId:  [],
      message: '',
    };
  }

  componentDidMount() {
    this.props.getAllPatient();
  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>RxRapidMad | Send SMS</title>
        </Helmet>

        <Container component="main" fixed className={classes.main}>
          <CssBaseline />
          <Formik
            initialValues={{
                patientId:[],
                message:'',
            }}
            validationSchema={Yup.object().shape({
              patientId: Yup.array().typeError('Invalid patient name').min(1, "Choose any one patient"),
                message: Yup.string()
                  .max(400)
                  .required("Message required"),
            })}
            onSubmit={(values, { setSubmitting }) => {
              this.setState({ submitted: true });
              var payload ={
                "patientId": 
                  values.patientId.map(x=>x.id)
                ,
                "message": values.message
              }
              this.props.submit(payload);
              console.log(JSON.stringify(payload));
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
            }) => (
              <form
                onSubmit={handleSubmit}
                className={classes.form}
                noValidate
                name="form"
              >
                <Box display="flex" pt={1} mt={1} mb={2}>
                  <Box flexGrow={1}>
                    <Typography
                      gutterBottom
                      variant="h4"
                      color="primary"
                      className={classes.typography}
                    >
                      {"Send SMS"}
                    </Typography>
                  </Box>
                </Box>
                <Box display="flex" p={1} bgcolor="background.paper">
                  <Box p={1} flexGrow={1}>
                  <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  options={this.props.allPatientList.map((option) => option)}
                  disableCloseOnSelect
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => {
                    return (
                      (option.firstName ? option.firstName : "") +
                      " " +
                      (option.lastName ? option.lastName : "")
                    );
                  }}
                  onChange={(event, newValue) => {
                    values.patientId = newValue;
                  }}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {(option.firstName ? option.firstName : "") +
                        " " +
                        (option.lastName ? option.lastName : "")}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                    {...params}
                    variant="outlined"
                    label="Patient Name"
                    placeholder="Patient Name"
                    error={Boolean(
                      touched.patientId && errors.patientId
                    )}
                    helperText={touched.patientId && errors.patientId}
                    id="patientId"
                    name="patientId"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.patientId}
                  /> 
                  )}
                />
                  </Box>
                </Box>
                <Box display="flex" p={1} bgcolor="background.paper">
                  <Box p={1} flexGrow={1}>
                  <TextField
                          error={Boolean(touched.message && errors.message)}
                          fullWidth
                          helperText={touched.message && errors.message}
                          label="Message "
                          margin="normal"
                          name="message"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.message}
                          variant="outlined"
                        />
                  </Box>
                </Box>

                <div className={classes.buttons}>
                  <Button
                    variant="contained"
                    color="default"
                    className={classes.button}
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    Back
                  </Button>

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={this.state.submitted}
                  >
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </Formik>

          <form
            className={classes.form}
            noValidate
            onSubmit={this.handleSubmit}
          ></form>
          <Paper className={classes.paper}></Paper>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const allPatientList = state.patient.all;
  const activeFormList = state.dynamicform.all;
  return { allPatientList, activeFormList};
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllPatient: () => dispatch(PatientActions.getAllPatients()),
    getActiveDynamicForm: () => dispatch(DynamicFormActions.getActiveDynamicFormRequest()),
    submit: (payload) =>  dispatch(PatientActions.sendPatientSMS(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(AssignDocument));
